import { Button, Card, CircularProgress, Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { InfoOutlined, VisibilityOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { ModalPreviewSec, UploadImage } from '../../../components';
import { getDataBeranda, updDataBeranda } from '../../../redux/actions/BerandaActions';

const Beranda = () => {
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        meta_desc_en: "",
        meta_desc_id: "",
        meta_title_en: "",
        meta_title_id: "",
        data: []
    });
    const [showPreview, setShowPreview] = useState(null)
    const handleChangeData = (name, value, idx) => {
        let data = params?.data;
        data[idx][name] = value;
        setParams(pref => ({
            ...pref,
            data: [...data]
        }));
    };
    const handleChange = ({target:{name, value}}) => {
        setParams(pref => ({
            ...pref,
            [name]: value
        }))
    }
    const handleFormSubmit = () => {
        setSubmit(true);
        updDataBeranda(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        })
    }, []);
    const handleChangeFoto = (name, file, idx) => {
        let data = params?.data;
        data[idx][name] = file
        data[idx][name+"_preview"] = file
        setParams(pref => ({...pref, data: [...data]}));
    };
    const getData = useCallback(() => {
        setLoading(true);
        getDataBeranda()
            .then((res) => {
                let data = res.data?.data;
                    setParams({
                        ...data,
                        data: data?.list?.map(item=> ({
                            ...item,
                            img: "",
                            img_preview: item.img,
                        }))
                    });
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data beranda, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [ showAlert]);
    useEffect(() => {
        getData();
    }, [getData, ]);
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Beranda - Kontent</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} className="mt-6">
                                        <h4 className="font-semibold">Informasi Halaman</h4>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_title_id"
                                            className="mb-4"
                                        >
                                            Meta Judul [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_title_id"
                                            placeholder="Meta Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_title_id"
                                            value={params.meta_title_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_title_en"
                                            className="mb-4"
                                        >
                                            Meta Judul [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_title_en"
                                            placeholder="Meta Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_title_en"
                                            value={params.meta_title_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_desc_id"
                                            className="mb-4"
                                        >
                                            Meta Deskripsi [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_desc_id"
                                            placeholder="Meta Deskripsi"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_desc_id"
                                            value={params.meta_desc_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Deskripsi terlebih dahulu'
                                            ]}
                                            multiline
                                            maxRows={16}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_desc_en"
                                            className="mb-4"
                                        >
                                            Meta Deskripsi [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_desc_en"
                                            placeholder="Meta Deskripsi"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_desc_en"
                                            value={params.meta_desc_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Deskripsi terlebih dahulu'
                                            ]}
                                            multiline
                                            maxRows={16}
                                        />
                                    </Grid>
                                    {
                                        params?.data?.map((item, idx) => (
                                            <>
                                                <Grid item xs={12} className="mt-6">
                                                    <h4 className="font-semibold">Bagian {idx + 1} <IconButton onClick={() => setShowPreview("beranda_"+idx+'.png')} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <UploadImage
                                                        uploadFoto={(file) => handleChangeFoto("img", file, idx)}
                                                        label="Unggah Foto"
                                                        preview={
                                                            item?.img_preview
                                                        }
                                                        required={true}
                                                        noCrop={true}
                                                        note={[
                                                            'Format PNG, JPG dan WEBP diperbolehkan',
                                                            '*Ukuran foto 1440 x 695'
                                                        ]}
                                                    />
                                                </Grid>
                                                {
                                                    idx !== 0 &&
                                                    <>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_text_atas_id"
                                                                className="mb-4"
                                                            >
                                                                Teks Atas [ID]{' '}
                                                                <span className="text-danger">*</span>
                                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                                    <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                                </Tooltip>
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_text_atas_id"
                                                                placeholder="Teks Atas"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_text_atas_id"
                                                                value={item?.home_text_atas_id || ''}
                                                                validators={['required']}
                                                                errorMessages={[
                                                                    'Masukkan Teks Atas terlebih dahulu'
                                                                ]}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_text_atas_en"
                                                                className="mb-4"
                                                            >
                                                                Teks Atas [EN]{' '}
                                                                <span className="text-danger">*</span>
                                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                                    <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                                </Tooltip>
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_text_atas_en"
                                                                placeholder="Teks Atas"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_text_atas_en"
                                                                value={item?.home_text_atas_en || ''}
                                                                validators={['required']}
                                                                errorMessages={[
                                                                    'Masukkan Teks Atas terlebih dahulu'
                                                                ]}
                                                            />
                                                        </Grid>
                                                    </>
                                                }
                                                <Grid item xs={12} md={6}>
                                                    <InputLabel
                                                        htmlFor="home_judul_id"
                                                        className="mb-4"
                                                    >
                                                        Judul [ID]{' '}
                                                        <span className="text-danger">*</span>
                                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                        </Tooltip>
                                                    </InputLabel>
                                                    <TextValidator
                                                        id="home_judul_id"
                                                        placeholder="Judul"
                                                        className="w-full"
                                                        variant="outlined"
                                                        onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                        type="text"
                                                        name="home_judul_id"
                                                        value={item?.home_judul_id || ''}
                                                        validators={['required']}
                                                        errorMessages={[
                                                            'Masukkan Judul terlebih dahulu'
                                                        ]}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <InputLabel
                                                        htmlFor="home_judul_en"
                                                        className="mb-4"
                                                    >
                                                        Judul [EN]{' '}
                                                        <span className="text-danger">*</span>
                                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                        </Tooltip>
                                                    </InputLabel>
                                                    <TextValidator
                                                        id="home_judul_en"
                                                        placeholder="Judul"
                                                        className="w-full"
                                                        variant="outlined"
                                                        onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                        type="text"
                                                        name="home_judul_en"
                                                        value={item?.home_judul_en || ''}
                                                        validators={['required']}
                                                        errorMessages={[
                                                            'Masukkan Judul terlebih dahulu'
                                                        ]}
                                                    />
                                                </Grid>
                                                {
                                                    idx !== 0 &&
                                                    <>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_sub_judul_id"
                                                                className="mb-4"
                                                            >
                                                                Sub Judul [ID]{' '}
                                                                <span className="text-danger">*</span>
                                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                                    <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                                </Tooltip>
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_sub_judul_id"
                                                                placeholder="Sub Judul"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_sub_judul_id"
                                                                value={item?.home_sub_judul_id || ''}
                                                                validators={['required']}
                                                                errorMessages={[
                                                                    'Masukkan Sub Judul terlebih dahulu'
                                                                ]}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_sub_judul_en"
                                                                className="mb-4"
                                                            >
                                                                Sub Judul [EN]{' '}
                                                                <span className="text-danger">*</span>
                                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                                    <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                                </Tooltip>
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_sub_judul_en"
                                                                placeholder="Sub Judul"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_sub_judul_en"
                                                                value={item?.home_sub_judul_en || ''}
                                                                validators={['required']}
                                                                errorMessages={[
                                                                    'Masukkan Sub Judul terlebih dahulu'
                                                                ]}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_text_tombol_id"
                                                                className="mb-4"
                                                            >
                                                                Teks Tombol [ID]{' '}
                                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                                    <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                                </Tooltip>
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_text_tombol_id"
                                                                placeholder="Teks Tombol"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_text_tombol_id"
                                                                value={item?.home_text_tombol_id || ''}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_text_tombol_en"
                                                                className="mb-4"
                                                            >
                                                                Teks Tombol [EN]{' '}
                                                                <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                                    <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                                                </Tooltip>
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_text_tombol_en"
                                                                placeholder="Teks Tombol"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_text_tombol_en"
                                                                value={item?.home_text_tombol_en || ''}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <InputLabel
                                                                htmlFor="home_halaman_tombol"
                                                                className="mb-4"
                                                            >
                                                                Halaman Tombol
                                                            </InputLabel>
                                                            <TextValidator
                                                                id="home_halaman_tombol"
                                                                placeholder="Contoh: /about-us"
                                                                className="w-full"
                                                                variant="outlined"
                                                                onChange={({target:{value,name}}) => handleChangeData(name, value, idx)}
                                                                type="text"
                                                                name="home_halaman_tombol"
                                                                value={item?.home_halaman_tombol || ''}
                                                            />
                                                        </Grid>
                                                    </>
                                                }
                                            </>
                                        ))
                                    }
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
            <ModalPreviewSec handleClose={() => setShowPreview(null)} img={`/assets/images/illustrations/${showPreview}`} open={showPreview} />
        </div>
    );
};

export default Beranda;
